import { TableColumnsType } from "antd";
import TableUi from "../../../../../atoms/Table";
import { useState } from "react";
import Filters from "./Filters";

export default function Materials() {
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [archived, isArchived] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const columns: TableColumnsType = [
    {
      title: "Measurement name",
      dataIndex: "measurement_name",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.measurement_name?.localeCompare(b?.measurement_name),
    },
    {
      title: "Value",
      dataIndex: "value",
      width: 150,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "center",
      sorter: (a, b) => a?.value?.localeCompare(b?.value),
    },
    {
      title: "Categories",
      dataIndex: "categories",
      width: 150,
      sorter: (a, b) => a?.categories?.localeCompare(b?.categories),
    },
    {
      title: "Last updated",
      dataIndex: "last_updated",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.last_updated?.localeCompare(b?.last_updated),
    },
  ];

  const dummyArray = [
    {
      key: "1a2b3c",
      measurement_name: "Turf for mowing with 30",
      value: "180,000 sqft",
      categories: "Softscape",
      last_updated: "March 21, 2025",
    },
    {
      key: "4d5e6f",
      measurement_name: "Turf for mowing with 48",
      value: "95,000 sqft",
      categories: "Softscape",
      last_updated: "March 21, 2025",
    },
    {
      key: "7g8h9i",
      measurement_name: "Hard edges length",
      value: "120,500 lf",
      categories: "Hardscape",
      last_updated: "March 21, 2025",
    },
    {
      key: "0j1k2l",
      measurement_name: "Soft edges length",
      value: "60,000 sf",
      categories: "Softscape",
      last_updated: "March 21, 2025",
    },
  ];

  return (
    <div>
      <TableUi
        columns={columns}
        data={{
          count: dummyArray?.length,
          data: dummyArray || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
}
